import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from "react-router-dom";

import Home from "./screens/Home";
import Products from "./screens/Products";
import AddProducts from "./screens/Products/Add";
import Articles from "./screens/Articles";
import AddArticles from "./screens/Articles/Add";
import Sellers from "./screens/Sellers";
import AddSellers from "./screens/Sellers/Add";
import Discover from "./screens/Discover";
import AddDiscover from "./screens/Discover/Add";
import Notifs from "./screens/Notifications";
import TestNotifs from "./screens/Notifications/Add";
import Auth from "./screens/Auth";

import "./App.css";
import { isAuth } from "./util";

function PrivateRoute({ children, ...rest }) {
  const auth = isAuth();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/auth",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function App() {
  return (
    <>
      <Router>
        <Switch>
          <PrivateRoute exact path="/products">
            <Products />
          </PrivateRoute>
          <PrivateRoute exact path="/products/add">
            <AddProducts />
          </PrivateRoute>
          <PrivateRoute exact path="/products/:id">
            <AddProducts />
          </PrivateRoute>
          <PrivateRoute exact path="/articles">
            <Articles />
          </PrivateRoute>
          <PrivateRoute exact path="/articles/add">
            <AddArticles />
          </PrivateRoute>
          <PrivateRoute exact path="/articles/:id">
            <AddArticles />
          </PrivateRoute>
          <Route exact path="/auth">
            <Auth />
          </Route>
          <PrivateRoute exact path="/sellers">
            <Sellers />
          </PrivateRoute>
          <PrivateRoute exact path="/sellers/add">
            <AddSellers />
          </PrivateRoute>
          <PrivateRoute exact path="/sellers/:id">
            <AddSellers />
          </PrivateRoute>
          <PrivateRoute exact path="/discover">
            <Discover />
          </PrivateRoute>
          <PrivateRoute exact path="/discover/add">
            <AddDiscover />
          </PrivateRoute>
          <PrivateRoute exact path="/discover/:id">
            <AddDiscover />
          </PrivateRoute>
          <PrivateRoute exact path="/notifs">
            <Notifs />
          </PrivateRoute>
          <PrivateRoute exact path="/notifs/test">
            <TestNotifs />
          </PrivateRoute>
          <PrivateRoute exact path="/">
            <Home />
          </PrivateRoute>
        </Switch>
      </Router>
    </>
  );
}

export default App;
